import React from "react";
import { Helmet } from "react-helmet";
import { corehrData } from "../assets/json/corehr";
import Blog from "../components/Blog/Blog";
import CoreHR from "../components/CoreHR/CoreHR";
import Hero from "../components/Home/Hero";
import HomeHero from "../components/Home/HomeHero";
import Howtowork from "../components/Howtowork/Howtowork";
import KeyFeature from "../components/KeyFeature/KeyFeature";
import Overview from "../components/Overview/Overview";
import RacipeLibrary from "../components/RacipeLibrary/RacipeLibrary";
import StartWithUs from "../components/StartWithUs/StartWithUs";
import WhySmartOffice from "../components/WhySmartOffice/WhySmartOffice";
import OptimizeTime from "../components/optimizeTime/OptimizeTime";
import "./../assets/css/home.css";
import { optimizeData } from "./../assets/json/optimizeData";
import { overviewData } from "./../assets/json/overviewData";

const Home = () => {

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Smart-Office</title>
      </Helmet>
      <HomeHero
        className="hero"
        title="SmartOffice Future of Work!"
        desc="All-in-one, future-ready workforce management 
solution—built on cutting edge technology to simplify, automate
and streamline key HR processes."
        btn="Free Signup"
      />
      <Overview data={overviewData} />
      <KeyFeature />
      <Howtowork />
      <WhySmartOffice />
      <RacipeLibrary />
      <CoreHR rowclassName="align-items-center" data={corehrData} />
      <Hero />
      <OptimizeTime rowclassName="align-items-center" data={optimizeData} />
      <StartWithUs />
      <Blog />
    </div>
  );
};

export default Home;
